import type { PermissionCheckResult } from './PermissionCheckResult.tsx';

/** Narrows the `assetsVertical_checkPermissions` union to its success results. */
export const extractPermissionResults = (
	checkPermissions:
		| {
				readonly __typename: string;
				readonly results?: ReadonlyArray<PermissionCheckResult> | null;
		  }
		| null
		| undefined,
): ReadonlyArray<PermissionCheckResult> =>
	checkPermissions?.__typename === 'AssetsVerticalCheckPermissionsSuccess'
		? (checkPermissions.results ?? [])
		: [];
